import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminSidebar from '../../../Container/AdminSidebar/AdminSidebar';
import { PatientUserDashboard } from '../../../components/PatientUser/PatientUserDashboard';
import PatientSidebar from '../../../Container/PatientSidebar/PatientSidebar';
import PatientProfile from '../../../components/PatientUser/PatientProfile';
import ShowAllPost from '../../../components/Post/ShowAllPost';
import PostDetilas from '../../../components/Post/PostDetilas';
import FullRichTextEditor from '../../../components/Post/FullRichTextEditor';


const PatientRoutes = () => {
  return (
    <div>
        <PatientSidebar/>
        <div style={{marginLeft:280,marginTop:25}}>

       
        <Routes>
            <Route path='/patient-dashboard' element={<PatientUserDashboard />} />
            <Route path='/user-profile/:id' element={<PatientProfile />} />
            
            <Route path='/sub-category/:id' element={<ShowAllPost />} />
            <Route path='/post-details/:id' element={<PostDetilas />} />
            <Route path='/rich-textbox' element={<FullRichTextEditor />} />
        
              
        </Routes>
        </div>
  </div>
  )
}

export default PatientRoutes